import React from "react";
import { Button, Space, Dropdown, Menu } from "antd";
import {
  PrinterOutlined,
  DownloadOutlined,
  ReloadOutlined,
  LockOutlined,
  DownOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import {
  getItems,
  getColumns,
  setHeader,
  setBottomContent,
} from "../../../components/print/printSections/prospectus";
import { exportReportToPdf } from "../../../components/util/helpers";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import {
  generateNewProspectus,
  approveEntireProspectus,
  rejectEntireProspectus,
  updateProspectusRecordAmounts,
  loadProspectuseslines,
  loadProspectus,
  lockEntireProspectus,
  unlockEntireProspectus,
} from "../prospectusSlice";
import { loadPage } from "../../prospectuses/prospectusesSlice";
import Detail from "./Detail";
import { generateBtlFile } from "../../../api/server";
import { openURL } from "../../../components/util/helpers";
import { useSuperAdmin } from "../../../hooks/accessControl";

const Header = (props) => {
  const {
    disabled,
    prospectuslines,
    onHide,
    hasAdminPermission,
    hasEditorPermission,
  } = props;
  const intl = useIntl();
  const dispatch = useDispatch();
  const activeProspectus = useSelector(
    (state) => state.prospectus.activeProspectus
  );
  const generateLoading = useSelector(
    (state) => state.pendingActions["prospectus/generate"]
  );
  const lockLoading = useSelector(
    (state) => state.pendingActions["prospectus/lock"]
  );

  const unockLoading = useSelector(
    (state) => state.pendingActions["prospectus/unlock"]
  );

  const organization = useSelector((state) => state.organization.details);
  const onCreateNewProspectus = async (record) => {
    const action = await dispatch(
      generateNewProspectus({
        branchId: activeProspectus.branch_id,
        parentId: activeProspectus.id,
      })
    );
    if (!action.error) {
      onHide();
      dispatch(loadPage());
    }
  };

  const onPrint = async () => {
    const items = getItems(prospectuslines, activeProspectus);
    const isSelfPayments =
      activeProspectus.payments && activeProspectus.payments?.name !== "";
    const headerRecord = {
      serial_number: activeProspectus.serial_number,
      year: activeProspectus.year,
      month: activeProspectus.month,
      organizationName: organization.name,
      taxId: organization.tax_id,
      serviceProviderNumber: organization.service_provider_number,
      supporting_community_service_provider_number:
        organization.supporting_community_service_provider_number,
      clientName: activeProspectus.client && activeProspectus.client.name,
      accountingCode:
        activeProspectus.client && activeProspectus.client.accounting_code,
      clientCategoryName:
        activeProspectus.client &&
        activeProspectus.client.category &&
        activeProspectus.client.category.name,
      comitteeNumber:
        activeProspectus.client &&
        activeProspectus.client.specific_data &&
        activeProspectus.client.specific_data.comittee_number,
      organizationBranchNumber:
        activeProspectus.client &&
        activeProspectus.client.specific_data &&
        activeProspectus.client.specific_data.organization_branch_number,
      isSocialSecurity:
        activeProspectus.client && activeProspectus.client.social_security,
      supporting_community: activeProspectus.supporting_community,
      day_center: activeProspectus.day_center,
      chargedAmount: activeProspectus.charged_amount,
      chargedUnits: activeProspectus.charged_units,
      createdAt: activeProspectus.created_at,
      branch: activeProspectus.branch,
      client: activeProspectus.client,
      isSelfPayments,
      is_self_participating: activeProspectus?.is_self_participating,
      paymentsName: activeProspectus.payments && activeProspectus.payments.name,
      paymentsAddress:
        activeProspectus.payments && activeProspectus.payments.address
          ? [
              activeProspectus.payments.address,
              activeProspectus.payments.city,
            ].join(", ")
          : "",
    };
    const columnStyles = getColumns(activeProspectus);
    exportReportToPdf(
      intl.formatMessage({
        id: "app.prospectuses.printForecastsFileName",
      }),
      items,
      setHeader,
      headerRecord,
      null,
      setBottomContent,
      items,
      "paging",
      40,
      intl,
      "prospectuses",
      {
        styles: { fontSize: 8.5 },
        columnStyles: columnStyles,
        margin: { top: 39 },
      },
      "l",
      "print"
    );
  };

  const onApproveEntireProspectus = async () => {
    const action = await dispatch(
      approveEntireProspectus({
        branchId: activeProspectus.branch_id,
        prospectusId: activeProspectus.id,
      })
    );
    if (!action.error) {
      dispatch(loadProspectuseslines());
      await dispatch(loadPage());
      dispatch(loadProspectus());
    }
  };

  const rejectProspectus = async () => {
    const action = await dispatch(
      rejectEntireProspectus({
        branchId: activeProspectus.branch_id,
        prospectusId: activeProspectus.id,
      })
    );
    if (!action.error) {
      dispatch(loadProspectuseslines());
      await dispatch(loadPage());
      dispatch(loadProspectus());
    }
  };

  const updateAmounts = async () => {
    const action = await dispatch(
      updateProspectusRecordAmounts({
        branchId: activeProspectus.branch_id,
        prospectusId: activeProspectus.id,
      })
    );
    if (!action.error) {
      dispatch(loadProspectuseslines());
      await dispatch(loadPage());
      dispatch(loadProspectus());
    }
  };

  const onLockProspectus = async () => {
    const action = await dispatch(
      lockEntireProspectus({
        branchId: activeProspectus.branch_id,
        prospectusId: activeProspectus.id,
      })
    );
    if (!action.error) {
      dispatch(loadProspectuseslines());
      await dispatch(loadPage());
      dispatch(loadProspectus());
    }
  };

  const onUnlockProspectus = async (record) => {
    const action = await dispatch(
      unlockEntireProspectus({
        branchId: activeProspectus.branch_id,
        prospectusId: activeProspectus.id,
      })
    );
    if (!action.error) {
      dispatch(loadProspectuseslines());
      await dispatch(loadPage());
      dispatch(loadProspectus());
    }
  };

  const onDownloadBtlFile = async () => {
    const params = {
      year: +activeProspectus.year,
      month: +activeProspectus.month,
      prospectuses: [activeProspectus.id],
    };
    const action = await generateBtlFile(params, activeProspectus.branch_id);
    openURL(action.file_url);
  };
  const handleMenuClick = (e) => {
    switch (e.key) {
      case "1":
        onPrint();
        break;
      case "2":
        onDownloadBtlFile();
        break;
      case "3":
        onApproveEntireProspectus();
        break;
      case "4":
        rejectProspectus();
        break;
      case "5":
        updateAmounts();
        break;
      default:
        break;
    }
  };
  const hasLockedLines = prospectuslines.find(
    (element) => element.locked === true
  )
    ? true
    : false;

  const isSuperAdmin = useSuperAdmin();

  let items = [
    {
      label: intl.formatMessage({
        id: "app.actions.print",
      }),
      key: "1",
      icon: <PrinterOutlined />,
      disabled: disabled,
    },
  ];

  if (
    activeProspectus &&
    activeProspectus.type !== "refund" &&
    activeProspectus.client &&
    activeProspectus.client.social_security
  ) {
    items.push({
      label: intl.formatMessage({
        id: "app.actions.download_file",
      }),
      key: "2",
      icon: <DownloadOutlined />,
      disabled: disabled,
    });
  }
  if (
    activeProspectus &&
    activeProspectus.locked === false &&
    activeProspectus.type !== "refund" &&
    !activeProspectus.canceled
  ) {
    items.push({
      label: intl.formatMessage({
        id: "app.actions.approveEntireProspectus",
      }),
      key: "3",
      icon: <CheckCircleOutlined />,
      disabled: !hasEditorPermission,
    });
  }

  if (
    activeProspectus &&
    !hasLockedLines &&
    !activeProspectus.parent_prospectus_id &&
    !activeProspectus.canceled
  ) {
    items.push({
      label: intl.formatMessage({
        id: "app.actions.rejectEntireProspectus",
      }),
      key: "4",
      icon: <CloseCircleOutlined />,
      disabled: !hasAdminPermission,
    });
  }

  if (isSuperAdmin) {
    items.push({
      label: intl.formatMessage({
        id: "app.actions.updateAmounts",
      }),
      key: "5",
      icon: <SyncOutlined />,
    });
  }

  const menu = {
    items,
    onClick: (e) => handleMenuClick(e),
  };
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "start",
      }}
    >
      {activeProspectus ? (
        <div>
          <Space style={{ alignItems: "baseline" }}>
            <Detail record={activeProspectus} name="year" />
            <Detail record={activeProspectus} name="month" />
            <Detail record={activeProspectus} name="serial_number" />
            <Detail
              record={{
                clientName:
                  activeProspectus.client && activeProspectus.client.name,
              }}
              name="clientName"
            />
            {activeProspectus.type !== "refund" && (
              <Detail
                record={activeProspectus}
                name="charged_units"
                style={{
                  direction: "ltr",
                  unicodeBidi: "bidi-override",
                  alignSelf: "flex-start",
                }}
              />
            )}

            {activeProspectus.type === "refund" && (
              <Detail
                record={{ refund_units: activeProspectus.charged_units }}
                name="refund_units"
                style={{
                  direction: "ltr",
                  unicodeBidi: "bidi-override",
                  alignSelf: "flex-start",
                }}
              />
            )}

            {activeProspectus.type !== "refund" && (
              <Detail
                record={activeProspectus}
                name="charged_amount"
                currency={true}
              />
            )}
            {activeProspectus.type !== "refund" && (
              <Detail
                record={activeProspectus}
                name="paid_amount"
                currency={true}
              />
            )}

            <Detail
              record={activeProspectus}
              name="reclaimed_amount"
              currency={true}
            />

            <Detail
              record={activeProspectus}
              name="refund_amount"
              currency={true}
            />
            {activeProspectus.type !== "refund" && (
              <Detail
                record={activeProspectus}
                name="balance"
                currency={true}
                warning={true}
              />
            )}

            {activeProspectus.type === "refund" && (
              <Detail
                record={{ total_refund: activeProspectus.charged_amount }}
                name="total_refund"
                currency={true}
              />
            )}

            {activeProspectus.type !== "refund" && (
              <Detail
                record={activeProspectus}
                name="over_payment_amount"
                currency={true}
              />
            )}

            {activeProspectus.is_self_participating && (
              <Detail
                record={activeProspectus}
                name="is_self_participating"
                highlight
              />
            )}
          </Space>
        </div>
      ) : null}
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div style={{ display: "flex" }}>
          <Space>
            {activeProspectus &&
            activeProspectus.balanced &&
            !activeProspectus.locked &&
            !(activeProspectus.reclaimable_amount > 0) ? (
              <Button
                type={"primary"}
                icon={<LockOutlined />}
                onClick={onLockProspectus}
                disabled={!hasEditorPermission || lockLoading}
                loading={lockLoading}
              >
                {intl.formatMessage({
                  id: "app.actions.lockProspectus",
                })}
              </Button>
            ) : (
              activeProspectus &&
              !activeProspectus.locked &&
              (activeProspectus.reclaimable_amount > 0 ||
                activeProspectus.refundable_amount > 0) && (
                <Button
                  type={"primary"}
                  icon={<ReloadOutlined />}
                  onClick={onCreateNewProspectus}
                  disabled={!hasEditorPermission || generateLoading}
                  loading={generateLoading}
                >
                  {intl.formatMessage({
                    id: "app.actions.createNewProspectus",
                  })}
                </Button>
              )
            )}
            {hasAdminPermission &&
              activeProspectus &&
              activeProspectus.locked && (
                <Button
                  type={"primary"}
                  icon={<ReloadOutlined />}
                  onClick={onUnlockProspectus}
                  loading={unockLoading}
                >
                  {intl.formatMessage({
                    id: "app.actions.unlockProspectus",
                  })}
                </Button>
              )}
            <Dropdown trigger={["click"]} menu={menu}>
              <Button type="link">
                {intl.formatMessage({
                  id: "app.salary.options",
                })}
                <DownOutlined />
              </Button>
            </Dropdown>
          </Space>
        </div>
      </div>
    </div>
  );
};

export default Header;
